import { RouteItem } from '@eastcoal/router/types/route'

import { PORT_PAGE_PATH } from './constants/path'
import { PORT_ACTION_UUID, PORT_PAGE_UUID } from './constants/uuid'

export const portRoute: RouteItem = {
  title: '港口管理',
  path: PORT_PAGE_PATH,
  hideChildrenInMenu: true,
  uuid: PORT_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理港口',
      uuid: PORT_ACTION_UUID
    }
  ]
}
